import { InfoJobsAction } from "Components/InfoJobs/Redux/actions";

export interface IInfoJobs {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.JobsPageViewModel;
};

const initialInfoJobs: IInfoJobs = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoJobs(
  state: IInfoJobs = initialInfoJobs, 
  action: InfoJobsAction,
  ): IInfoJobs {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_JOBS_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_JOBS_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_JOBS_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoJobs;


// WEBPACK FOOTER //
// ./src/components/InfoJobs/Redux/reducer.tsx